import { passwordValidator } from './password-validator';

export * from './email-validator';
export * from './prevent-future-date-validator';
export * from './password-validator';
export * from './value-validator';
export * from './prevent-previous-date-validator';
export * from './cnpj-formatters';
export * from './competence-validator';

passwordValidator();
